export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';
export const SELECT_COUNTRY = 'SELECT_COUNTRY';



// WEBPACK FOOTER //
// ./src/store/country/countryActionTypes.js